<template>
  <div class="otto-notification" v-bind:class="classObject">
    <div class="otto-notification__info">
      <p class="otto-notification__title" v-bind:class="type">{{this.title}}</p>
      <p class="otto-notification__copy">{{this.copy}}</p>
    </div>
    <div class="otto-notification__actions">
      <div @click="onCancel" class="otto-notification__icon otto-notification__icon--cancel"><Cancel /></div>
      <div @click="onSubmit" class="otto-notification__icon"><Complete /></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { mapActions, mapGetters } from 'vuex';
import { ADD_TOAST_MESSAGE } from 'vuex-toast';
import moment from 'moment-timezone';
import Cancel from '@/components/Cancel.svg';
import Complete from '@/components/Complete.svg';
import {
  getNotificationDataForType,
  mapNotificationForCancel,
  mapNotificationForBooking,
  mapNotificationForReschedule,
} from '@/utils';

export default {
  name: 'notification',
  props: ['notification'],
  components: {
    Cancel,
    Complete,
  },
  mounted() {
    this.data = getNotificationDataForType(this.notification.pending_appointment_type);
    this.type = this.data.type;
    this.title = this.data.title;
    this.action = this.data.action;
  },
  data() {
    return {
      type: null,
      action: null,
      title: null,
      hiding: false,
    };
  },
  computed: {
    ...mapGetters([
      'currentTimezone',
    ]),
    classObject() {
      let obj = {
        hiding: this.hiding,
      };
      if (this.type) {
        obj = Object.assign(obj, this.type);
      }

      return obj;
    },
    copy() {
      const {
        client_first_name,
        client_last_name,
        start_time,
        source_description,
      } = this.notification;
      const name = client_first_name ? `${client_first_name} ${client_last_name}` : 'Someone';
      const date = moment.tz(start_time, this.currentTimezone).format('dddd[,] MMM D[ at ]h:mmA');
      const source = source_description ? ` through ${source_description}.` : '.';
      const output = `${name} ${this.action} ${date}${source}`;
      return output;
    },
  },
  methods: {
    ...mapActions([
      'hideNotification',
      'deleteAppointment',
      'updateAppointment',
      'rescheduleAppointment',
      'bookNotification',
      'closeNotifications',
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE,
    }),
    showModal(text, handler) {
      this.$modal.show('dialog', {
        text,
        buttons: [{
          title: 'Cancel',
        }, {
          title: 'OK',
          default: true,
          handler,
        }],
      });
    },
    onCancel() {
      if (this.hiding) {
        return;
      }
      this.showModal('Dismiss Notification?', this.hide);
    },
    cancel() {
      this.$modal.hide('dialog');
      this.hiding = true;
      const app = mapNotificationForCancel(this.notification);
      this.deleteAppointment(app).then(() => {
        this.hideNotification(this.notification._id).then(() => {
          this.addToast({
            text: 'Appointment cancelled.',
            type: 'success',
          });
        });
      }).catch((err) => {
        console.log('error cancelling notification', err);
        this.hiding = false;
      });
    },
    hide() {
      this.$modal.hide('dialog');
      this.hiding = true;
      this.hideNotification(this.notification._id)
        .then(() => {
          this.addToast({
            text: 'Notification dismissed.',
            type: 'success',
          });
        })
        .catch((err) => {
          console.log('error hdiding notification', err);
          this.hiding = false;
        });
    },
    reschedule() {
      this.$modal.hide('dialog');
      this.hiding = true;
      const app = mapNotificationForReschedule(this.notification);
      this.rescheduleAppointment(app).then(() => {
        this.hideNotification(this.notification._id).then(() => {
          this.addToast({
            text: 'Appointment rescheduled.',
            type: 'success',
          });
        });
      }).catch((err) => {
        console.log('error rescheduling notification', err);
        this.hiding = false;
      });
    },
    book() {
      const app = mapNotificationForBooking(this.notification);
      this.closeNotifications();
      this.bookNotification(app);
    },
    onSubmit() {
      if (this.hiding) {
        return;
      }
      switch (this.notification.pending_appointment_type) {
        case 0:
          this.book();
          return;
        case 1:
          this.showModal(this.data.text, this.cancel);
          return;
        case 2:
          this.showModal(this.data.text, this.reschedule);
          return;
        default:
          this.book();
      }
    },
  },
};
</script>
<style lang="sass" src="@/assets/styles/notifications.sass"></style>




// WEBPACK FOOTER //
// src/components/Notification.vue